module.exports = __webpack_public_path__ + "img/slide_1.e8ed967.jpg";